import jindalStar from "@/assets/brands/jindal-star.webp";
import tataPipes from "@/assets/brands/tata-pipes.webp";
import kartar from "@/assets/brands/kartar.webp";
import zoloto from "@/assets/brands/zoloto.webp";
import normex from "@/assets/brands/normex.webp";
import matrix from "@/assets/brands/matrix.webp";
import racer from "@/assets/brands/racer.webp";
import vs from "@/assets/brands/vs.webp";
import kitz from "@/assets/brands/kitz.webp";
import nezone from "@/assets/brands/nezone.webp";
import bestarc from "@/assets/brands/bestarc.webp";
import kranti from "@/assets/brands/kranti.webp";
import maharashtraSeamless from "@/assets/brands/maharashtra-seamless.webp";

const brands = [
  { name: "Jindal Star", logo: jindalStar },
  { name: "Tata Pipes", logo: tataPipes },
  { name: "Kartar", logo: kartar },
  { name: "Zoloto Valves", logo: zoloto },
  { name: "Normex Valves", logo: normex },
  { name: "Matrix", logo: matrix },
  { name: "Racer", logo: racer },
  { name: "VS", logo: vs },
  { name: "Kitz", logo: kitz },
  { name: "Nezone", logo: nezone },
  { name: "Bestarc", logo: bestarc },
  { name: "Kranti", logo: kranti },
  { name: "Maharashtra Seamless", logo: maharashtraSeamless },
];

const repeatedBrands = [...brands, ...brands];

const logoSizes: Record<string, { width: number; height: number }> = {
  "Jindal Star": { width: 320, height: 125 },
  "Tata Pipes": { width: 113, height: 73 },
  Kartar: { width: 258, height: 70 },
  "Zoloto Valves": { width: 238, height: 128 },
  "Normex Valves": { width: 270, height: 110 },
  Matrix: { width: 128, height: 128 },
  Racer: { width: 90, height: 90 },
  VS: { width: 200, height: 128 },
  Kitz: { width: 320, height: 80 },
  Nezone: { width: 286, height: 128 },
  Bestarc: { width: 213, height: 128 },
  Kranti: { width: 128, height: 128 },
  "Maharashtra Seamless": { width: 231, height: 128 },
};

const BrandCarousel = () => (
  <section className="py-12 bg-card border-y border-border overflow-hidden">
    <div className="container mx-auto px-4 mb-6">
      <p className="text-center text-accent-strong font-display text-sm uppercase tracking-[0.2em]">
        Trusted Brands We Deal In
      </p>
    </div>
    <div className="relative overflow-hidden">
      <div className="flex w-max min-w-max items-center gap-5 pr-5 will-change-transform animate-[scroll-left_14s_linear_infinite] md:animate-[scroll-left_10s_linear_infinite]">
        {repeatedBrands.map((brand, i) => {
          const isClone = i >= brands.length;

          return (
          <div
            key={`${brand.name}-${i}`}
            aria-hidden={isClone}
            className="flex h-24 min-w-[172px] flex-shrink-0 items-center justify-center rounded-md border border-border bg-background px-6 py-4 sm:min-w-[190px]"
          >
            {brand.logo ? (
              <img
                src={brand.logo}
                alt={`${brand.name} — Authorized dealer Taher Steel Coimbatore`}
                loading="lazy"
                className="max-h-16 w-auto max-w-full object-contain"
                width={logoSizes[brand.name]?.width}
                height={logoSizes[brand.name]?.height}
              />
            ) : (
              <span className="font-display text-lg font-bold text-foreground/70 tracking-wide whitespace-nowrap">
                {brand.name}
              </span>
            )}
          </div>
        )})}
      </div>
    </div>
  </section>
);

export default BrandCarousel;
